import { BSkeletonImg } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBSkeletonImg when migrating. */
export const EgBSkeletonImg = createEgBootstrapProxy(
  "EgBSkeletonImg",
  BSkeletonImg
);
